import { on } from '@ember/modifier';
import { action } from '@ember/object';

import type { PopupData } from 'webapp-types';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import type { Args as PopupInnerBaseArgs } from 'webapp/components/popup/inner/base';
import PopupInnerBaseComponent from 'webapp/components/popup/inner/base';
import SearchableListComponent from 'webapp/components/searchable-list';

import type PopupList from 'webapp/models-custom/popup/popup-list';

export interface Args extends PopupInnerBaseArgs {
	model: PopupList;
}

// !!! IMPORTANT !!! only use this with models-custom/popup/popup-list models

export default class PopupListComponent extends PopupInnerBaseComponent<Args> {
	get popupData() {
		return this.args.model.data as PopupData.Common.List;
	}

	get itemsList() {
		return this.popupData.itemsList;
	}

	get searchableProperties() {
		return this.popupData.searchableProperties!;
	}

	get hideDropdownSearch() {
		return this.popupData.hideDropdownSearch;
	}

	get theme() {
		return this.args.model.theme;
	}

	get popupModel(): PopupList {
		return this.args.model;
	}

	get showClearSelection(): boolean {
		return !!this.popupData.onClearSelection;
	}

	get title() {
		return this.popupData.title;
	}

	@action
	doAction(actionName?: string, ...args: unknown[]): void {
		this.popupData.doAction(actionName, ...args);

		if (!this.popupData.skipCloseOnAction) {
			this.close();
		}
	}

	@action
	handleClearSelection(): void {
		if (this.popupData.onClearSelection) {
			this.popupData.onClearSelection();
		}
	}

	@action
	handleMouseLeave(): void {
		this.popupModel.startCloseTimer();
	}

	@action
	handleMouseEnter(): void {
		this.popupModel.cancelCloseTimer();
	}
	<template>
		<div
			{{on "mouseenter" this.handleMouseEnter}}
			{{on "mouseleave" this.handleMouseLeave}}
			class="popup-list {{if this.showClearSelection 'popup-list--with-clear'}}"
		>
			<div class="popup-list__content">
				{{#if this.title}}
					<div class="title">{{this.title}}</div>
				{{/if}}
				<SearchableListComponent
					@itemsList={{this.itemsList}}
					@searchableProperties={{this.searchableProperties}}
					@forceHideSearch={{this.hideDropdownSearch}}
					@onAction={{this.doAction}}
					@theme={{this.theme}}
					@popup={{this.popupModel}}
				/>
			</div>
			{{#if this.showClearSelection}}
				<a
					role="button"
					class="popup-list__clear-btn"
					{{on "click" this.handleClearSelection}}
				>
					<CommonUiIconComponent @name="Close" @size="md" />
					Reset filter
				</a>
			{{/if}}
		</div>
	</template>
}
